import img1 from './assets/img/collabs/cultural.jpg';
import img2 from './assets/img/collabs/drmc-science.jpg';
import img3 from './assets/img/collabs/drmc-tech.jpg';
import img4 from './assets/img/collabs/drmc-art.jpg';
import img5 from './assets/img/collabs/voix.jpg';
import img6 from './assets/img/collabs/encore.jpg';
import img7 from './assets/img/collabs/odyssey.jpg';
import img8 from './assets/img/collabs/jbc.jpg';
import img9 from './assets/img/collabs/humanity.jpg';
import img10 from './assets/img/collabs/talents.jpg';
import img11 from './assets/img/collabs/teachers.jpg';
import img12 from './assets/img/collabs/techwarno.jpg';
import img13 from './assets/img/collabs/mon.jpg';


export const collabs = [
    {
        title: 'Cultural Mania 2.0',
        text: 'Hey Stop!!! Wait a moment! Are you feeling bored? Hoping for something better than before? Then here is the good news for you. Not only for you but also for your near &amp; dear ones. Are you excited!',
        link: 'https://fb.me/e/2uV5m6YHg',
        img: img1
    },
    {
        title: 'DRMC Virtual National Science Carnival',
        text: 'With the mission to encourage juvenile learners in eternal science related activities, once again DRMC Science Club is ready to represent the biggest, the most exciting and the glorious event on the 61st founding anniversary of DRMC - "Virtual National Science Carnival-2021" of Dhaka Residential Model College.',
        link: 'https://fb.me/e/1kAyshq9e',
        img: img2
    },
    {
        title: 'DRMC Virtual National Tech Carnival 2021',
        text: '  Upholding its glory for igniting the innovative prowess of the youth, Celebrating 61 years of Dhaka Residential Model College, DRMC IT Club has the immense pleasure of inviting you to our tech carnival. Hopefully, this is going to be the largest concourse ever for tech enthusiasts all over the nation, as it welcomes digital luminaries from around the globe to present the beauty and complexity of the ever-growing world. ',
        link: 'https://fb.me/e/1qP1P03V0',
        img: img3
    },
    {
        title: 'Remains Art Club Presents DRMC Virtual Art Showdown 2021',
        text: 'Remians Art Club Presents “ DRMC Virtual Art Showdown 2021 “.The finest platform for artistic talent showcasing is finally here to explore and encourage the primal forms of art and culture. The main focus of this competition is to gather all the talents from all over the country and showcase the best of the best amongst them.',
        link: 'https://fb.me/e/19fnQFKI4',
        img: img4,
        aos: "fade-up"
    },
    {
        title: 'Alate Presents - Voix 1.0',
        text: "26th March is our Independence day and with every declaration of Independence there is a speech, speech is the very right, the very soul, the very words that motivates people. ALATE along with their intentions to improve youth public speaking enhances the quality and mysticism of capturing people's mindset through speech just like our Father of Nation, Sheikh Mujibur Rahman did. ALATE is always looking forward to providing opportunities to the young talented minds to boost their skills.",
        link: 'https://fb.me/e/1Y7PUJLpl',
        img: img5,
        aos: "fade-up"
    },
    {
        title: 'Engage Presents Encore Creativity Flourish Your Skills',
        text: 'Since the very inception of ‘Engage’, it has been working solely with the core scheme and sterling determination to brawl and combat the mental health issue along with the evolution of the skills of the youth through their active captivation. Merging with this string, amidst this pandemic, we are back with "Encore Creativity" where you can Flourish Your Skills and win amazing prizes!',
        link: 'https://fb.me/e/2E8OZjPSN',
        img: img6,
        aos: "fade-up"
    },
    {
        title: 'iTeach Online 1.0 Odyssey Begins',
        text: 'Are you feeling bored in this pandemic? SSC and HSC examination are knocking at the door? But you are always not in the mood to study, right? Then we have a good news for you. What if you get some rewards and certificates and get prepared for your examination as well? Sounds interesting? Then pls go through the details below to know more about it! ',
        link: 'https://fb.me/e/1T4hQ3JWU',
        img: img7,
        aos: "fade-up"
    },
    {
        title: "Walton 3rd Josephite Entrepreneurs' Den",
        text: 'Josephite Business club has returned with a 3rd installment of its flagship event, Josephite Entrepreneurs’ Den. This year, our motto is “Outclassing Obstacles”. JBC has been organizing Josephite Entrepreneurs’ Den since 2018 with the goal of making it the biggest most innovative national business event of Bangladesh.',
        link: 'https://fb.me/e/3p3zUzNfd',
        img: img8,
        aos: "fade-up"
    },
    {
        title: 'Humans With Humanity',
        text: '  ‘Humans with Humanity’ is an event based on enhancing and bringing out the ideas of the people regarding humanity and social service. It shall be conducted from 7th-9th of January (the finals). The event will act as a medium for people to talk about their perspective towards the society and will try to bring out the inner concepts of people, providing them with a platform to pour them.    ',
        link: 'https://fb.me/e/13v4471eQ',
        img: img9,
        aos: "fade-up"
    },
    {
        title: 'Labrynth of Talents 1.0',
        text: '   Hey Stop!!! Wait a moment!Are you feeling bored? Hoping something better than before?Then here is the good news for you.Not only for you but also for your near &amp; dear ones.Are you excited! Thinking what is the good news?Okay!!!  ',
        link: 'https://fb.me/e/Tfjbs6up',
        img: img10,
        aos: "fade-up"
    },
    {
        title: "TAAN_RAAT Presents World Teacher's Day Online Fiesta",
        text: 'TAAN_RAAT Group is organizing a special event on “World Teacher’s Day”, 2020 to show respect to all the teachers all over the world. TAAN_RAAT presents “World Teacher’s Day Online Fiesta 2020” ',
        link: 'https://fb.me/e/11jn8amXW',
        img: img11,
        aos: "fade-up"
    },
    {
        title: 'Techwarno 1.0',
        text: '   The current pandemic and the ensuing lockdown has no doubt had a heavy toll on our daily affairs (and happiness), spurring endless boredom and procrastination about what to do. But it has served as a moment of opportunity as well, as an impetus to creative pursuits. It has encouraged us to venture out into new domains of knowledge, to explore new fields, to broaden our horizons, to educate and exceed ourselves in ways which were unthought of in the past.   ',
        link: 'https://fb.me/e/VVLhCrk0',
        img: img12,
        aos: "fade-up"
    },
    {
        title: '“বিদ্যালয়ে মনোবিদ, সুস্থ মন প্রতিদিন” Campaign',
        text: '  Our campaign, "বিদ্যালয়ে মনোবিদ, সুস্থ মন প্রতিদিন" targets the lack of professional counseling in the educational institutions of Bangladesh. The main motive behind the campaign is to raise public awareness about the very topic. Schools play a huge role in shaping a child to an upstanding and well adjusted member of our society. The mental health of a student is as important as his physical health.   ',
        link: 'https://fb.me/e/5VZSLH6At',
        img: img13,
        aos: "fade-up"
    },
];